import { z } from 'zod';

export const settingsSchema = z.object({
  allowApproveAndReject: z.boolean().optional(),
  allowEditProfile: z.boolean().optional(),
});

export type SettingsSchema = z.infer<typeof settingsSchema>;
